export default "__VITE_ASSET__CRq8sSPV__"